"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _ArbitrumL2BitcoinDepositor_extraDataEncoder, _ArbitrumL2BitcoinDepositor_depositOwner;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArbitrumL2BitcoinDepositor = void 0;
const adapter_1 = require("../ethereum/adapter");
const contracts_1 = require("../contracts");
const ethereum_1 = require("../ethereum");
const utils_1 = require("../utils");
const ArbitrumL2BitcoinDepositor_json_1 = __importDefault(require("./artifacts/arbitrumOne/ArbitrumL2BitcoinDepositor.json"));
const ArbitrumL2BitcoinDepositor_json_2 = __importDefault(require("./artifacts/arbitrumSepolia/ArbitrumL2BitcoinDepositor.json"));
/**
 * Implementation of the Arbitrum L2BitcoinDepositor handle.
 * @see {L2BitcoinDepositor} for reference.
 */
class ArbitrumL2BitcoinDepositor extends adapter_1.EthersContractHandle {
    constructor(config, chainId) {
        let deployment;
        switch (chainId) {
            case contracts_1.Chains.Arbitrum.ArbitrumSepolia:
                deployment = ArbitrumL2BitcoinDepositor_json_2.default;
                break;
            case contracts_1.Chains.Arbitrum.Arbitrum:
                deployment = ArbitrumL2BitcoinDepositor_json_1.default;
                break;
            default:
                throw new Error("Unsupported deployment type");
        }
        super(config, deployment);
        _ArbitrumL2BitcoinDepositor_extraDataEncoder.set(this, void 0);
        _ArbitrumL2BitcoinDepositor_depositOwner.set(this, void 0);
        __classPrivateFieldSet(this, _ArbitrumL2BitcoinDepositor_extraDataEncoder, new ethereum_1.EthereumCrossChainExtraDataEncoder(), "f");
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2BitcoinDepositor#getChainIdentifier}
     */
    getChainIdentifier() {
        return ethereum_1.EthereumAddress.from(this._instance.address);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2BitcoinDepositor#getDepositOwner}
     */
    getDepositOwner() {
        return __classPrivateFieldGet(this, _ArbitrumL2BitcoinDepositor_depositOwner, "f");
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2BitcoinDepositor#setDepositOwner}
     */
    setDepositOwner(depositOwner) {
        __classPrivateFieldSet(this, _ArbitrumL2BitcoinDepositor_depositOwner, depositOwner, "f");
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2BitcoinDepositor#extraDataEncoder}
     */
    extraDataEncoder() {
        return __classPrivateFieldGet(this, _ArbitrumL2BitcoinDepositor_extraDataEncoder, "f");
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L2BitcoinDepositor#initializeDeposit}
     */
    async initializeDeposit(depositTx, depositOutputIndex, deposit, vault) {
        const { fundingTx, reveal } = (0, ethereum_1.packRevealDepositParameters)(depositTx, depositOutputIndex, deposit, vault);
        if (!deposit.extraData) {
            throw new Error("Extra data is required");
        }
        const l2DepositOwner = this.extraDataEncoder().decodeDepositOwner(deposit.extraData);
        const tx = await this._instance.initializeDeposit(fundingTx, reveal, `0x${l2DepositOwner.identifierHex}`);
        return utils_1.Hex.from(tx.hash);
    }
}
exports.ArbitrumL2BitcoinDepositor = ArbitrumL2BitcoinDepositor;
_ArbitrumL2BitcoinDepositor_extraDataEncoder = new WeakMap(), _ArbitrumL2BitcoinDepositor_depositOwner = new WeakMap();
//# sourceMappingURL=l2-bitcoin-depositor.js.map